import './card-social-media.scss';

export default () => {

};
